import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input", "button"]

  handleForm(e) {
    e.preventDefault()
    if (this.inputTarget.value) {
      this.submitForm(e)
    }
  }

  submitForm(e) {
    if (confirm(e.target.dataset.confirm)) {
      this.formTarget.submit()
    }
  }
}
